exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "textarea {\n  min-width: 500px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/UsersModule/UserEditComponent/user-edit.component.scss
// module id = ../../../../../src/UsersModule/UserEditComponent/user-edit.component.scss
// module chunks = main